export const white = '#FFFFFF';
export const black = '#474747';
export const grey = '#CCCCCB';
export const lightGrey = '#F7F8f8';
export const pink = '#FBE1DD';
export const highlight = pink;
